import React, { createContext, useState } from 'react';
import propTypes from 'prop-types';

const loadState = Object.freeze({
  EMPTY: 'empty',
  FINALIZING: 'finalizing',
  ERROR: 'error',
});

const QuoteContext = createContext();

const QuoteProvider = ({ installationType, children }) => {
  const [installOption, setInstallOption] = useState(installationType);
  const [addons, setAddons] = useState([]);
  const [loadingState, setLoadingState] = useState(loadState.EMPTY);

  return (
    <QuoteContext.Provider
      value={{
        installOption,
        setInstallOption,
        addons,
        setAddons,
        loadState,
        loadingState,
        setLoadingState,
      }}
    >
      {children}
    </QuoteContext.Provider>
  );
};

QuoteProvider.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
  ]),
  installationType: propTypes.shape({
    id: propTypes.number,
    productType: propTypes.string,
    sku: propTypes.string,
  }),
};

export { QuoteProvider, QuoteContext };
